import ReusableSectionService from 'services/document-templates/ReusableSectionService'

export default function(editor) {
    return {
        text: null,
        icon: 'save',
        tooltip: 'Save reusable section',
        onclick : () => {
            let selectedContent = editor.selection.getContent()
            if (!selectedContent) {
                editor.notificationManager.open({
                    text: 'No selection provided. Nothing to save',
                    type: 'info'
                });

                return
            }

            editor.windowManager.open({
                title: 'Save reusable section',
                width: 700,
                height: 200,
                body: [{
                    type: 'textbox',
                    name: 'section',
                    id: 'section-name',
                    label: 'Section name'
                }],
                buttons: [{
                    text: 'Save',
                    classes: 'widget btn primary first',
                    onclick: async () => {
                        let content = editor.selection.getContent()
                        let service = new ReusableSectionService;
                        let data = {
                            content: content,
                            name: $('#section-name').val()
                        }
                        try {
                            let response = await service.save(data)
                            editor.notificationManager.open({
                                text: response.data.message,
                                type: 'success'
                            });
                        } catch (error) {
                            editor.notificationManager.open({
                                text: error.data.message,
                                type: 'error'
                            });
                        }

                        editor.windowManager.close(this);
                    },
                }, {
                    text: 'Cancel',
                    onclick: 'close'
                }]
            });

        }
    }
}

